.issuer-card {
  background-color: #fcfcfc;
  opacity: 0.8;
  background-image: repeating-radial-gradient(circle at 0 0, transparent 0, #ffff 10px),
    repeating-linear-gradient(#e2e2e2, #fff);
  transition: transform 200ms ease-in-out;
}
